export default {"src":"/_next/static/media/bolt.5be64cdc.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};